// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "b713fe65959a";
export const BUILD_VERSION_NUMBER = 24;
